import { useFeatureFlags } from '@ApplicationWide/feature-flags';
import { filterRoutes } from '@ApplicationWide/routes/routeUtils';
import ADMIN_ROUTES_NOT_IN_NAVBAR from './nonNavbarAdminRoutes';
import ADMIN_ROUTES_IN_NAVBAR from './navbarAdminRoutes';

const ADMIN_ROUTES = [...ADMIN_ROUTES_IN_NAVBAR, ...ADMIN_ROUTES_NOT_IN_NAVBAR];

export const useAvailableAdminNavBarRoutes = () => {
  const featureFlags = useFeatureFlags();
  return filterRoutes(ADMIN_ROUTES_IN_NAVBAR, featureFlags);
};

export const useAvailableAdminRoutes = () => {
  const featureFlags = useFeatureFlags();
  return filterRoutes(ADMIN_ROUTES, featureFlags);
};
